import { CheckRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import { exportCheckItem } from '@/api/api'

const crsp = new CheckRecordServiceProxy()

const checkRecord = {
  create: crsp.addCheckRecord.bind(crsp) as typeof crsp.addCheckRecord,
  update: (...args: Parameters<typeof crsp.updateCheckRecord>) => crsp.updateCheckRecord(...args),
  read: crsp.page.bind(crsp) as typeof crsp.page,
  delete: crsp.deleteCheckRecord.bind(crsp) as typeof crsp.deleteCheckRecord,
  export: exportCheckItem,
}

const checkItem = {
  read: crsp.checkRecordItemList.bind(crsp) as typeof crsp.checkRecordItemList
}

export { checkRecord, checkItem }
